import { createSlice } from "@reduxjs/toolkit";
import { fetchReportsData, getClientWiseCompletedReport } from "../actions/ReportsActions";


const fetchReportsDataSlice = createSlice({
    name: 'fetchReportsData',
    initialState: {
        loading: false,
        data: null,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchReportsData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchReportsData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                // Call the success callback if provided
                if (typeof action.meta.arg.successFn === 'function') {
                    action.meta.arg.successFn(action.payload);
                    console.log("action page", action.payload)
                }
            })
            .addCase(fetchReportsData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
                // Call the failure callback if provided
                if (typeof action.meta.arg.failureFn === 'function') {
                    action.meta.arg.failureFn(action.error.message);
                    console.log("action:::", action.error.message)
                }
            });
    }
  });

const getClientWiseCompletedReportSlice = createSlice({
    name: 'getClientWiseCompletedReport',
    initialState: {
        loading: false,
        data: null,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getClientWiseCompletedReport.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getClientWiseCompletedReport.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                // Call the success callback if provided
                if (typeof action.meta.arg.successFn === 'function') {
                    action.meta.arg.successFn(action.payload);
                    console.log("action page", action.payload)
                }
            })
            .addCase(getClientWiseCompletedReport.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
                // Call the failure callback if provided
                if (typeof action.meta.arg.failureFn === 'function') {
                    action.meta.arg.failureFn(action.error.message);
                    console.log("action:::", action.error.message)
                }
            });
    }
  });

  export const reducers = {
    fetchReportsData: fetchReportsDataSlice.reducer,
    getClientWiseCompletedReport: getClientWiseCompletedReportSlice.reducer,
  }